import React from 'react'

import { BrowserRouter, Route, Routes } from 'react-router-dom'

import DocumentationLayout from './layouts/Documantation'
import ClarificationText from './layouts/Documantation/ClarificationText'
import KVKK from './layouts/Documantation/KVKK'
import PrivacyPolicy from './layouts/Documantation/PrivacyPolicy'
import SartlarVeKosullar from './layouts/Documantation/SartlarVeKosullar'
import TermsOfUse from './layouts/Documantation/TermsOfUse'
import Home from './layouts/Home'
import VenueScreen from './layouts/VenueMain'

const AuthRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Home />} />

        <Route exact path="/policy" element={<DocumentationLayout />} >
          <Route exact path="/policy" element={<PrivacyPolicy />} />
        </Route>

        <Route exact path="/termsofuse" element={<DocumentationLayout />} >
          <Route exact path="/termsofuse" element={<TermsOfUse />} />
        </Route>

        <Route exact path="/clarification" element={<DocumentationLayout />} >
          <Route exact path="/clarification" element={<ClarificationText />} />
        </Route>

        <Route exact path="/kvkk" element={<DocumentationLayout />} >
          <Route exact path="/kvkk" element={<KVKK />} />
        </Route>

        <Route exact path="/sartlar-kosullar" element={<DocumentationLayout />} >
          <Route exact path="/sartlar-kosullar" element={<SartlarVeKosullar />} />
        </Route>

        <Route path="/:alias" element={<VenueScreen />} >
          <Route path=":tableID" element={<VenueScreen />} />
        </Route>
        <Route exact path="/r/:resId" element={<VenueScreen />} />

      </Routes>
    </BrowserRouter>
  )
}

export default AuthRouter
